import request from '@/utils/service'
import qs from 'qs'

// 主页banner
export function banners(params) {
    return request({
        url: '/pc/banners',
        method: 'GET',
        params
    })
  }

  // 获取logo文字
export function getLogoWrite(params) {
  return request({
    url: '/logo',
    method: 'GET',
    params
  })
}
/**
* @description 获取店铺列表
* @param {*} params 
*/
export function stores(params) {
    return request({
        url: '/stores',
        method: 'GET',
        params
    })
}

/**
 * @description 获取城市列表
 * @param {*} params 
 */
export function cities(params) {
    return request({
        url: '/cities',
        method: 'GET',
        params
    })
}